import { rem } from 'polished';
import { css } from '../../styles/theme';

export const StylesAC = css`
    margin-bottom: ${rem(48)};

    span,
    a {
        text-decoration: none;
        margin: 0 0.5rem;
        color: ${({ theme }) => theme.colors.black};
        text-transform: capitalize;
        font-size: ${rem('14px')};
        font-family: ${({ theme }) => theme.fonts.fontBase};
        &:first-child {
            margin-left: 0;

            &::before {
                content: '';
                margin: 0;
            }
        }
        &::before {
            display: inline-block;
            color: ${({ theme }) => theme.colors.black};
            content: '>';
            margin-right: 0.5rem;
        }
    }

    span {
        font-weight: ${({ theme }) => theme.fontWeights.textBold};

        &::before {
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
        }
    }
`;
